import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
// import { SelectRegionModalComponent } from '@ibe.components/shared/select-region-modal/select-region-modal.tap.component';
import { Airport } from '@ibe/models';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as Sifter from 'sifter';
import * as fromStore from '../../../store';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteService } from './autocomplete.tap.service';
import { Subscription } from 'rxjs';

import { INDRASelectRegionModalComponent } from '@ibe.components/shared/select-region-modal/select-region-modal.indra.component';
import { INDRASelectThemeModalComponent } from '@ibe.components/shared/select-theme-modal/select-theme-modal.indra.component';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { SESSION_VAR_KEY_SEARCH_ROUTE } from '@ibe.config';


@Component({
	selector: 'app-autocomplete',
	templateUrl: './autocomplete.indra.component.html',
	styleUrls: ['./autocomplete.component.scss'],
	host: {
		class: 'autocomplete'
	},
	providers: [AutocompleteService]
})
export class INDRAAutocompleteComponent extends AutocompleteComponent
	implements OnInit, OnChanges, OnDestroy {
	@Input()
	query: String = '';

	@Input()
	focused = false;

	@Input()
	showResults = false;

	@Input()
	dataOptions = []; // select options

	@Input()
	completeOptions = [];

	// @Input() // possibly not needed
	// showRecentSearch = true;

	@Input()
	showLastSearch = true;

	@Input()
	callback;
	
	@Input()
	isTripFinder = false;

	@Input()
	id = '';

	@Output()
	selected: EventEmitter<any>;
	isSelected = false;
	shouldOpen = false;

	loading: boolean = false;
	loadingTimeout;

	@Output()
	focusedResult = -1;

	resultsAriaAlert = '';

	autocompleteOptions = [
		{
			label: 'Search.text.searchByRegion',
			icon: 'icons.svg#plane_related--route',
			id: 'seach-region',
			aria: 'Search.aria.searchByRegion'
		},
		// {
		// 	label: 'Search.text.searchByTheme',
		// 	icon: 'icons.svg#destinations--beach',
		// 	id: 'seach-theme',
		// 	aria: 'Search.aria.searchByTheme'
		// }, {
		// 	label: 'Search.text.searchAnywhere',
		// 	description: 'Search.description.searchAnywhere',
		// 	icon: 'icons.svg#interface--language',
		// 	id: 'seach-anywhere',
		// 	aria: 'Search.aria.searchAnywhere'
		// }
	];

	lastSearchOptions = [];

	private url: string;

	/**
	 * Airport list filtered by this.query;
	 */
	results: Array<any> = [];

	/**
	 * Complete list of airports;
	 * Must not be changed outside of service requests
	 */
	// data: Array<any>;
	// subFetch: Subscription;

	constructor(
		private fetcher: AutocompleteService,
		private modalService: ModalService,
		private store: Store<fromStore.State>,
		private ibeAdminService: INDRAIbeAdminService) {

		super();
		this.selected = new EventEmitter<string>();

		if (localStorage && localStorage.getItem(SESSION_VAR_KEY_SEARCH_ROUTE)) {
			const SearchRoute = JSON.parse(localStorage.getItem(SESSION_VAR_KEY_SEARCH_ROUTE));
			this.lastSearchOptions.push({ type: 'recent-search', value: SearchRoute });
		}
	}

	/**
	 * Keyboard listener
	 * Navigate on autocomlete using keyboard
	 */
	@HostListener('window:keyup', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		event.stopPropagation();
		if (this.showResults) {
			this.shouldOpen = true;
			switch (event.key) {
				case 'ArrowUp':
					if (this.focusedResult > 0) {
						this.focusedResult--;
						this.INDRA_updateFocusedResultAriaAlert();
					}
					break;
				case 'ArrowDown':
					if (this.focusedResult < this.results.length - 1) {
						this.focusedResult++;
						this.INDRA_updateFocusedResultAriaAlert();
					}
					break;
				case 'Enter':
					this.INDRA_selectFromAutocomplete();
					break;
				case 'Tab':
					this.INDRA_selectFromAutocomplete();
					break;
				default:
					return;
			}
		}
	}

	INDRA_handleLastSearchClick(option) {
		this.isSelected = true;
		this.selected.emit(option);
	}

	INDRA_handleOptionClick(id) {
		switch (id) {
			case 'seach-region':
				this.modalService.assignComponent(INDRASelectRegionModalComponent, {
					params: {
						id: this.id
					},
					handleClose: (event) => {
						this.selected.emit(event);
						if (this.callback) this.callback(event);
					}
				});
				this.modalService.open();
				break;
			case 'seach-theme':
				this.modalService.assignComponent(INDRASelectRegionModalComponent, this.callback);
				this.modalService.open();
				break;
			case 'seach-anywhere':
				const item = {
					type: 'anywhere',
					value: {
						label: this.INDRA_getTextTranslation('Search.text.searchAnywhere'),
						description: this.INDRA_getTextTranslation('Search.description.searchAnywhere'),
						icon: 'interface--language',
						id: 'seach-anywhere'
					}
				};

				this.isSelected = true;
				this.selected.emit(item);

				break;
			default:
				break;
		}
	}

	/**
	 * Perform selection of airport from autocomplete list
	 * Called from Keyboard listner
	 */
	INDRA_selectFromAutocomplete() {
		if (this.results.length > 1) {
			this.INDRA_handleSelect(this.results[this.focusedResult]);
		} else if (this.results.length === 1) {
			this.INDRA_handleSelect(this.results[0]);
		} else {
			this.INDRA_handleSelect(null);
		}
	}

	ngOnInit() {
		/* // Get list of airport mocks
		this.url = './assets/data/airports.json';
		this.subFetch = this.fetcher
			.getResults(this.url)
			.subscribe(
				data => (this.data = this.handleData(data)),
				error => console.error(error)
			);
		*/

		if (this.completeOptions.length)
			this.autocompleteOptions = this.autocompleteOptions.filter(cur => this.completeOptions.includes(cur.id));
	}

	/**
	 * Handles a response and translates it for the template results
	 * @param res data got from response
	 * @returns data as expected for the template
	 */
	private handleData(res): Array<any> {
		if (res instanceof Array) {
			return res;
		} else {
			return res.data.origins;
		}
	}

	/**
	 * Filters the results based on the query
	 */
	ngOnChanges() {
		if (this.query == undefined) {
			return;
		} else if (this.query == '') {
			// this.selected.emit(null);
			this.results = [];
		} else if (this.dataOptions && this.query !== '') {
			this.INDRA_simulateLoading();
			const dataToScore = new Sifter(this.dataOptions);
			const queryToScore = this.query.replace(/[^A-Za-z]/g, ' ');

			let score = dataToScore.search(queryToScore, {
				fields: ['code', 'location.city', 'location.country', 'name'],
				sort: [{ field: 'code', direction: 'asc' }],
				nesting: true,
				filter: true,
				conjunction: 'and',
				limit: 6
			});

			score.items.forEach(option => {
				const airport = this.dataOptions[option.id];
				if(airport.isRailway){
					option.score -= 1;
				}
			});
			
			// Sort the results again based on the new scores
			score.items.sort((a, b) => b.score - a.score);

			const filteredResults = [];
			const self = this;
			score.items.forEach(function (item) {
				filteredResults.push(self.dataOptions[item.id]);
			});

			this.results = filteredResults;
		} else {
			this.results = [];
		}

		if (this.focusedResult < 0 && this.results.length > 0) {
			this.focusedResult = 0;
		} else if (this.focusedResult > this.results.length - 1) {
			this.focusedResult = this.results.length - 1;
		}

		this.INDRA_updateResultsAriaAlert();
	}

	/**
	 * Set focused class on autocomplete
	 */
	INDRA_isFocusedResult(index: number): object {
		return { 'has-focus': index === this.focusedResult };
	}

	/**
	 * Returns whether the results panel should be shown
	 */
	INDRA_showResults(): boolean {
		if (
			this.shouldOpen &&
			this.showResults &&
			this.results &&
			!this.loading &&
			this.results.length > 0
		) {
			return true;
		}
		return false;
	}

	/**
	 * Emits to parent the selected result
	 * @param result Selected result
	 */
	INDRA_handleSelect(result) {
		this.shouldOpen = false;
		if (result !== null) {
			this.isSelected = true;
			this.selected.emit(result);
			this.resultsAriaAlert = this.INDRA_printAirportName(result) + this.INDRA_printAirportCountry(result) + ' selected.';
		} else {
			this.isSelected = false;
		}
	}

	/**
	 * Returns airport to autocomplete list
	 * @param result customized airport result text
	 */
	INDRA_printAirportName(result: Airport): string {
		// Check if airport name is diferent then city name
		const airportName = result.location.city.toLowerCase() === result.name.toLowerCase() ? '' : result.name + ', ';
		return (result.location.city + ', ' + airportName);
	}

	/**
	 * Print airport iata code on input
	 */
	INDRA_printAirportCountry(result: Airport): String {
		if (result && result.location) {
			return result.location.country;
		}
		return '';
	}

	/**
	 * Print airport iata code on input
	 */
	INDRA_printAirportCode(result: Airport): String {
		if (result && result.location) {
			return result.code;
		}
		return '';
	}

	INDRA_updateResultsAriaAlert() {
		let ariaMessage = '';

		ariaMessage += this.results.length;

		if (this.showResults) {
			if (this.results.length === 0) {
				ariaMessage += this.INDRA_getTextTranslation('Search.aria.resultsFound');
			} else if (this.results.length === 1) {
				ariaMessage += this.INDRA_getTextTranslation('Search.aria.resultsAvailable') + this.INDRA_printSelectResultAria(this.results[0]);
			} else {
				ariaMessage += this.INDRA_getTextTranslation('Search.aria.useUpAndDown') + this.INDRA_printSelectResultAria(this.results[0]);
			}
			this.resultsAriaAlert = ariaMessage;
		}
	}

	INDRA_updateFocusedResultAriaAlert() {
		if (this.focusedResult !== -1) {
			this.resultsAriaAlert = this.INDRA_printSelectResultAria(this.results[this.focusedResult]);
		} else {
			this.resultsAriaAlert = '';
		}
	}

	INDRA_printSelectResultAria(result: Airport): string {
		return 'Select ' + this.INDRA_printAirportName(result) + this.INDRA_printAirportCountry(result);
	}

	INDRA_simulateLoading() {
		if (this.focused) {
			this.loading = true;
			clearTimeout(this.loadingTimeout);
			this.loadingTimeout = setTimeout(() => { this.loading = false; }, 400);
		}
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	ngOnDestroy() {
		// this.subFetch.unsubscribe();
	}
}
